<template>
  <div class="paybillList">
    <div class="header" v-if="content.CurrencyList && content.CurrencyList.length > 0">
      <van-row class="currency-row">
        <van-col span="6"></van-col>
        <van-col
          span="6"
          v-for="(currency, index) in content.CurrencyList"
          :key="index"
          >{{ currency.CurrencySn }}</van-col
        >
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.paybillList.totalAmount }}</van-col>
        <van-col span="6">{{ content.Currency1_TotalAmount }}</van-col>
        <van-col span="6">{{ content.Currency2_TotalAmount }}</van-col>
        <van-col span="6">{{ content.Currency3_TotalAmount }}</van-col>
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.paybillList.approvedAmount }}</van-col>
        <van-col span="6">{{ content.Currency1_ApprovedAmount }}</van-col>
        <van-col span="6">{{ content.Currency2_ApprovedAmount }}</van-col>
        <van-col span="6">{{ content.Currency3_ApprovedAmount }}</van-col>
      </van-row>
    </div>
    <div class="content" v-if="content.PayBillList && content.PayBillList.length > 0">
      <div class="bill" v-for="(bill, index) in content.PayBillList" :key="index">
        <div class="bill-title">
          <div class="bill-title-left">{{ bill.InvoiceNo }}</div>
          <div class="bill-title-right">
            <span v-if="bill.BillState == 1" class="red">{{
              $t.paybillList.billState1
            }}</span>
            <span v-if="bill.BillState == 2" class="blue">{{
              $t.paybillList.billState2
            }}</span>
            <span v-if="bill.BillState == 3" class="green">{{
              $t.paybillList.billState3
            }}</span>
          </div>
        </div>
        <div class="bill-header">
          <van-row class="currency-row">
            <van-col span="6"></van-col>
            <van-col
              span="6"
              v-for="(currency, index) in content.CurrencyList"
              :key="index"
              >{{ currency.CurrencySn }}</van-col
            >
          </van-row>
          <van-row class="amount-row">
            <van-col span="6">{{ $t.paybillList.subTotalAmount }}</van-col>
            <van-col span="6">{{ bill.Currency1_SubTotalAmount }}</van-col>
            <van-col span="6">{{ bill.Currency2_SubTotalAmount }}</van-col>
            <van-col span="6">{{ bill.Currency3_SubTotalAmount }}</van-col>
          </van-row>
          <van-row class="amount-row">
            <van-col span="6">{{ $t.paybillList.subApprovedAmount }}</van-col>
            <van-col span="6">{{ bill.Currency1_SubApprovedAmount }}</van-col>
            <van-col span="6">{{ bill.Currency2_SubApprovedAmount }}</van-col>
            <van-col span="6">{{ bill.Currency3_SubApprovedAmount }}</van-col>
          </van-row>
        </div>
        <van-collapse v-model="activeNames" @change="getPayBillDetail(bill, $event)">
          <van-collapse-item :title="$t.paybillList.chargeMoney" :name="index">
            <template v-if="bill.items && bill.items.length > 0">
              <van-row class="bill-row" v-for="(detail, idx) in bill.items" :key="idx">
                <van-col span="12">{{ detail.ItemName }}</van-col>
                <van-col span="12">{{ detail.CurrencySymbol }} {{ detail.Rate }}</van-col>
              </van-row>
            </template>
            <van-loading
              size="24"
              type="spinner"
              color="#009ed4"
              style="padding: 10px; text-align: center"
              v-else
            />
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Col, Row, Button, Collapse, CollapseItem, Loading } from "vant";
import PayWindow from "@components/payWindow/PayWindow.vue";

Vue.use(Col).use(Row).use(Button).use(Collapse).use(CollapseItem).use(Loading);

export default {
  name: "paybillList",
  data() {
    return {
      wbNumber: "",
      nuclearAccountNo: "",
      content: {},
      activeNames: [],
    };
  },
  mounted() {},
  created() {
    const query = this.$route.query;
    if (query.wbNumber) {
      this.wbNumber = query.wbNumber;
      this.getCustomerPayBillList();
    }
    if (query.NuclearAccountNo) {
      this.nuclearAccountNo = query.NuclearAccountNo;
      this.getCustomerPayBillListByNuclearAccountNo();
    }
  },
  methods: {
    getCustomerPayBillList() {
      this.$commonMethod.showLoading();
      var param = {
        WB_Number: this.wbNumber,
      };
      return new Promise((resolve) => {
        this.$api.myWallet
          .getCustomerPayBillList(param)
          .then((res) => {
            this.content = res.data;
            for (var bill of this.content.PayBillList) {
              bill.items = [];
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCustomerPayBillListByNuclearAccountNo() {
      this.$commonMethod.showLoading();
      var param = {
        NuclearAccountNo: this.nuclearAccountNo,
      };
      return new Promise((resolve) => {
        this.$api.myWallet
          .getCustomerPayBillListByNuclearAccountNo(param)
          .then((res) => {
            this.content = res.data;
            for (var bill of this.content.PayBillList) {
              bill.items = [];
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getPayBillDetail(bill, event) {
      if (event.length > 0) {
        var param = {
          InvoiceNo: bill.InvoiceNo,
        };
        return new Promise((resolve) => {
          this.$api.myWallet
            .getPayBillDetail(param)
            .then((res) => {
              setTimeout(() => {
                bill.items = res.data;
                this.$forceUpdate();
              }, 500);
              resolve(true);
            })
            .catch((error) => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
                msg: error.message,
              });
            });
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.paybillList {
  .header {
    padding: 10px;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;
    .currency-row {
      background: #009ed4;
      color: white;
      .van-col {
        padding-left: 10px;
        line-height: 35px;
      }
    }
    .amount-row {
      .van-col {
        padding-left: 10px;
        line-height: 35px;
      }
    }
  }
  .content {
    ::v-deep .van-collapse-item__content {
      padding: 10px;
      background: transparent;
    }
    .van-collapse-item {
      ::v-deep .van-cell {
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
      }
    }
    ::v-deep .van-cell__title {
      text-align: center;
      span {
        padding-left: 20px;
      }
    }
    .bill {
      width: 95%;
      margin: 2% auto auto auto;
      box-shadow: 0px 2.5px 6.5px 1px rgba(0, 0, 0, 0.1);
      .bill-title {
        padding: 10px;
        .bill-title-left {
          font-size: 14px;
          vertical-align: middle;
          display: inline-block;
          width: 70%;
        }
        .bill-title-right {
          font-size: 14px;
          vertical-align: middle;
          display: inline-block;
          width: 29%;
          text-align: right;
          margin-right: 1%;
          .red {
            color: red;
          }
          .blue {
            color: blue;
          }
          .green {
            color: green;
          }
        }
      }
      .bill-header {
        padding: 10px;
        font-size: 14px;
        .currency-row {
          background: #009ed4;
          color: white;
          .van-col {
            padding-left: 10px;
            line-height: 35px;
          }
        }
        .amount-row {
          .van-col {
            padding-left: 10px;
            line-height: 35px;
          }
        }
      }
    }
    .bill-row {
      .van-col {
        padding-right: 10px;
        text-align: center;
        line-height: 35px;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
